import { Link } from "react-router-dom";
import styled from "styled-components";

const A = styled.a`
  padding: 6px 8px 6px 16px;
  text-decoration: none;
  font-size: 25px;
  color: #818181;
  display: block;
  font-size: 1.2rem;
`;

const Home = () => {
  return (
    <>
      <h1>Temas</h1>
      <A as={Link} to="/apresentacao/flexstore">
        FlexStore
      </A>
      <A as={Link} to="/apresentacao/altstore">
        Altstore
      </A>
    </>
  );
};

export default Home;
